import { render, staticRenderFns } from "./DetailConsequence.vue?vue&type=template&id=d1d3cf0a"
import script from "./DetailConsequence.vue?vue&type=script&lang=js"
export * from "./DetailConsequence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports